module.exports = __webpack_public_path__ + "static/img/PK10.187f325.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/PK10.png
// module id = nsVc
// module chunks = 7